function TransComponent(props: { content: JSX.Element }) {
  return props.content;
}

export default TransComponent;
